module.exports = __webpack_public_path__ + "static/media/logo_header.d1f3e572.png";